<template>
  <div>
    <v-container class="">
      <v-layout row wrap style="xborder: 1px solid red;">
        <v-flex xs12  xl10 offset-xl1>
          <v-card row class="mt-4" 
            v-if="this.$store.state.auth.user">
            <v-card-title primary-title class="grey lighten-4">
              <h3 class="headline mb-0">Hallo {{ this.$store.state.auth.user.name }}!</h3>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p
                class="subheading mt-2"
              >Wir freuen uns, Sie in der Pionierphase von LokalesHandwerk.de willkommen zu heißen!</p>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    
 <v-container xclass="pa-0 ma-0">
      <v-layout row wrap>
        
        <v-flex xs12 xl10 offset-xl1 style="xborder: 1px solid red;">
          <betrieb-check></betrieb-check>
          <!-- <MeineAnzeigen></MeineAnzeigen> -->
          <!-- <span v-if="this.$store.getters.authBetrieb">
            <stripe-check v-if="this.$store.getters.authBetrieb.name"></stripe-check>
          </span> -->
        </v-flex>
      </v-layout>
    </v-container>


    <!-- <v-container fluid>
      <v-layout row wrap="" class="">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md0 lg5 offset-lg1 xl5 offset-xl2>
          <home-news></home-news>
        </v-flex>
        <v-flex xs12 sm10 offset-sm1 md4 offset-md0 lg5 offset-lg0 xl3>
          <betrieb-check></betrieb-check>
           <MeineAnzeigen></MeineAnzeigen>
           <span v-if="this.$store.getters.authBetrieb">
            <stripe-check v-if="this.$store.getters.authBetrieb.name"></stripe-check>
          </span>
        </v-flex>
      </v-layout>
    </v-container> -->

<!-- <pricing-table></pricing-table> -->
  <!-- <v-container class="mb-2">
      <v-layout row wrap style="xborder: 1px solid red;">
        <v-flex xs12  xl10 offset-xl1>
<sparkline></sparkline>
        </v-flex></v-layout></v-container> -->


  </div>
</template>

<script>

// import { mapGetters } from 'vuex'
// import StripePay from '~/components/StripePay.vue'
// import StripeIbanElement from '~/components/StripeIbanElement.vue'

// import UpdatesStart from '~/components/updates/UpdatesStart.vue'

// import StripeCheck from '~/components/dashboard/StripeCheck.vue'
import BetriebCheck from '~/components/dashboard/BetriebCheck.vue'
import HomeNews from '~/components/dashboard/HomeNews.vue'

// import PricingTable from '~/components/dashboard/PricingTable.vue'
import Sparkline from '~/components/dashboard/Sparkline.vue'

// import MeineAnzeigen from '~/components/dashboard/MeineAnzeigen.vue'

// import MailSend from '~/components/dashboard/MailSend.vue'

export default {
  components: {
        // StripePay,
    HomeNews,
   // PricingTable,
   // StripeCheck,
    BetriebCheck,
    Sparkline
    // MeineAnzeigen

        // UpdatesStart
       // MailSend,

  },
  // name: 'home-view',
  metaInfo () {
    return { title: this.$t('home') }
  },
  mounted: function () {

  },

  created () {

  },
  data: function () {
    return {
      e1: '4',
      companyId: '',
      premiumloading: true
                // name: '',
    }
  }

}
</script>


